export const SEND_RETENO_ANALYTICS_REQUEST = 'SEND_RETENO_ANALYTICS_REQUEST';
